import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './reducers';
import { loadState } from './LocalStorage';

const persistedState = loadState();
var initialState = persistedState != null
? persistedState
: {};

if( Object.keys(initialState).length ){
  initialState.defaultReducer.tickets = [];
  initialState.defaultReducer.services = [];
  initialState.defaultReducer.servicesSubscriptions = [];
  initialState.defaultReducer.users = [];
  initialState.defaultReducer.branches = [];
  initialState.defaultReducer.reportRange = "";
  initialState.defaultReducer.reportId = "";
  initialState.defaultReducer.reportTypes = [];
  initialState.defaultReducer.reportsData = {};
}

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
